import React, { Component } from 'react';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';
import ReactTable from 'react-table';
import IconTd from '../ReusableComponents/IconTd';
// import { LoaderWrapper } from '../ReusableComponents';
import { __ } from '../../Utils';

const Wrapper = styled.div`
  width: 100%;
  .ReactTable.-striped .rt-tr.-odd {
    background-color: ${props => props.striped && '#f0f0f0'};
  }
  .ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
    background-color: ${({ theme, striped }) =>
      striped && `${theme.color.primary}55`};
  }
`;

class DataTable extends Component {
  useCustomheader(columns) {
    return columns.map(i => ({
      Header: () => <IconTd>{i.name}</IconTd>,
      ...i,
    }));
  }
  render() {
    const props = Object.assign({}, this.props, {
      columns: this.useCustomheader(this.props.columns),
    });

    const { loading, striped } = this.props;

    // if (loading) {
    //   return (
    //     <LoaderWrapper>
    //       <Loader size="xl" color={loadingColor} />
    //     </LoaderWrapper>
    //   );
    // }

    return (
      <Wrapper striped={striped}>
        <ReactTable
          {...props}
          loading={loading}
          loadingText={__('Načítavam dáta ...')}
          noDataText={__('Dáta sa nenašli')}
          getTheadProps={(state, rowInfo, column, instance) => {
            return Object.assign(
              {},
              {
                style: {
                  boxShadow: 'unset',
                  padding: `${rem(10)} 0`,
                  borderBottom: `solid ${rem(0.5)} ${baseTheme.color.disabled}`,
                  top: 0,
                },
              },
              this.props.getTheadProps(state, rowInfo, column, instance),
            );
          }}
          getTheadThProps={(state, rowInfo, column, instance) => {
            return Object.assign(
              {},
              {
                style: {
                  outline: 'none',
                  cursor: 'auto',
                },
                onClick: () => {},
              },
              this.props.getTheadThProps(state, rowInfo, column, instance),
            );
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return Object.assign(
              {},
              {
                style: {
                  outline: 'none',
                },
                onClick: () => {},
              },
              this.props.getTdProps(state, rowInfo, column, instance),
            );
          }}
          showPagination={false}
        />
      </Wrapper>
    );
  }
}

DataTable.propTypes = {
  getTheadProps: PropTypes.func,
  getTheadThProps: PropTypes.func,
  getTdProps: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.any),
  style: PropTypes.objectOf(PropTypes.any),
  striped: PropTypes.bool,
};

DataTable.defaultProps = {
  getTdProps: () => {},
  getTheadProps: () => {},
  getTheadThProps: () => {},
  columns: [],
  style: {},
  striped: true,
};

export default DataTable;



// WEBPACK FOOTER //
// ./src/Components/Table/index.jsx